import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'icon-button',
    templateUrl: './icon-button.component.html',
    styleUrl: './icon-button.component.css',
})
export class IconButtonComponent {
    @Input() label: string = '';
    @Input() icon: string = '';

    @Input() styleClass: string = '';
    @Input() isRound: boolean = false;

    getStyleClass() {
        let newStyleClass: { [key: string]: boolean } = {
            'rem-btn-round': this.isRound,
        };

        if (this.styleClass) {
            newStyleClass[this.styleClass] = true;
        }

        return newStyleClass;
    }
}
